import {
  FETCH_ORDENES,
  FETCH_ORDEN,
  EDIT_ORDEN,
  FETCH_ORDENES_EN_VERDE,
  FETCH_CLIENTE,
  LOADING_ORDENES,
  SET_FILTRO_ORDENES
} from './types';
import {
  getOrden,
  fetchOrdenesParams,
  fetchOrdenesEnVerdeParams
} from "../api/axios";
import { nuevaOrden } from '../helper/ordenHelper'

export const fetchOrdenes = (request) => async dispatch => {
  dispatch({
    type: LOADING_ORDENES,
    payload: true
  });

  if (request.idOrden != "") {
    request.fechaDesde = "";
    request.fechaHasta = "";
  }

  let array = fetchOrdenesParams(request);
  array.then((ordenes) => {
    dispatch({
      type: FETCH_ORDENES,
      payload: ordenes
    });

    dispatch({
      type: LOADING_ORDENES,
      payload: false
    });
  })
}

export const fetchOrdenesEnVerde = (request) => async dispatch => {
  dispatch({
    type: LOADING_ORDENES,
    payload: true
  });

  if (request.idOrden != "") {
    request.fechaDesde = "";
    request.fechaHasta = "";
  }

  let array = fetchOrdenesEnVerdeParams(request);
  array.then((ordenesEnVerde) => {
    dispatch({
      type: FETCH_ORDENES_EN_VERDE,
      payload: ordenesEnVerde
    });

    dispatch({
      type: LOADING_ORDENES,
      payload: false
    });
  })
}

export const fetchOrden = (id) => async dispatch => {
  dispatch({
    type: LOADING_ORDENES,
    payload: true
  });

  if (id != undefined) {
    let orden = getOrden(id);

    orden.then((orden) => {
      dispatch({
        type: FETCH_ORDEN,
        payload: orden.elementos[0]
      });

      dispatch({
        type: LOADING_ORDENES,
        payload: false
      });
    })

  } else {
    dispatch({
      type: FETCH_ORDEN,
      payload: nuevaOrden()
    });

    dispatch({
      type: LOADING_ORDENES,
      payload: false
    });
  }
}

export const fetchDatosComprador = (id) => async dispatch => {
  dispatch({
    type: LOADING_ORDENES,
    payload: true
  });

  let ordenNew = {
    "nombre": "",
    "apellido": "",
    "tipoDocumento": "",
    "documento": 0,
    "domicilio": "",
    "numeroDomicilio": "",
    "piso": "",
    "departamento": "",
    "codigoPostal": "",
    "localidad": "",
    "provincia": "",
    "codigoProvincia": "",
    "email": "",
    "prefijoTelefono": "",
    "telefono": "",
    "prefijoCelular": "",
    "numeroCelular": "",
    "sexo": "",
    "situacionIva": "",
    "cuit": ""
  }

  if (id != undefined) {
    let orden = getOrden(id);
    orden.then((orden) => {
      dispatch({
        type: FETCH_CLIENTE,
        payload: orden.elementos[0].cliente
      });

      dispatch({
        type: LOADING_ORDENES,
        payload: false
      });
    })
  } else {
    dispatch({
      type: FETCH_CLIENTE,
      payload: ordenNew
    });

    dispatch({
      type: LOADING_ORDENES,
      payload: false
    });
  }
}

export const editDatosComprador = (orden) => dispatch => {
  dispatch({
    type: FETCH_CLIENTE,
    payload: orden
  });
}

export const editOrden = (orden) => dispatch => {
  dispatch({
    type: EDIT_ORDEN,
    payload: orden
  });
}

export const setFiltroOrdenes = (filtro) => dispatch => {
  dispatch({
    type: SET_FILTRO_ORDENES,
    payload: filtro
  });
}